<template>
  <div>
    <h1 class="mb-3">Редактирование контроллера</h1>
    <v-form ref="formEditController" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" sm="5">
          <v-row>
            <v-card-text class="pb-0">Данные о контроллере</v-card-text>
            <v-col cols="12" sm="10" class="py-0 pt-3">
              <v-combobox
                v-model="formController.address"
                @keyup="startTypingTimer"
                @input="updateAddressSearch"
                ref="addressInput"
                prepend-inner-icon="mdi-rename-box-outline"
                :rules="[
                  () => !!formController.address || 'Обязательное поле',
                ]"
                :items="isFirstLoading ? [formController.address] : addresses"
                item-text="addresses"
                return-object
                flat
                label="Адрес"
                outlined
                dense
              ></v-combobox>
            </v-col>
            <v-col cols="12" sm="10" class="py-0">
              <v-autocomplete
                label="Район (только для г. Саранск)"
                v-model='formController.region'
                :items="district"
                :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
                item-value="id"
                prepend-inner-icon="mdi-map-marker-radius-outline"
                type="string"
                outlined
                :disabled="!isDistrict"
                dense
                flat
              />
            </v-col>
            <v-col cols="12" sm="10" class="py-0">
              <v-text-field
                label="Название в моб. приложении"
                v-model='formController.name'
                prepend-inner-icon="mdi-rename-outline"
                type="string"
                outlined
                clearable
                dense
                flat
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="10" class="py-0">
              <v-autocomplete
                label="Физический статус"
                prepend-inner-icon="mdi-progress-clock"
                :items="physicalStatus"
                v-model='formController.physicalStatus'
                :rules="[
                  () => !!formController.physicalStatus || 'Обязательное поле',
                ]"
                item-text="status"
                item-value="id"
                clearable
                outlined
                dense
                flat
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mx-auto">
              <BindingDoorphone />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="7" class="pb-0">
          <v-col cols="12" class="px-0" v-if="currentDevice">
            <v-sheet
              color="green"
              dense
              outlined
              class="pa-4 mx-0"
            >
              {{ currentDevice }}
            </v-sheet>
          </v-col>
          <v-card>
            <v-card-title>
              <span>Устройства</span>
              <v-col cols="12" sm="10" md="10" lg="9">
                <v-text-field
                  v-model="searchDevice"
                  label="Поиск по IP адресу"
                  dense
                  autocomplete="chrome-off"
                  hide-details
                  @keyup="(e) => e.keyCode === 13 && filterDevices()"
                ></v-text-field>
              </v-col>
              <v-btn
                dark
                class="btn blue darken-3 white px-7 text-none"
                @click.prevent="filterDevices"
              >
                Поиск
              </v-btn>
            </v-card-title>
            <v-data-table
              class="table"
              v-model="selectedDevices"
              :options.sync="universalOptions"
              :server-items-length="universalTotalDevices"
              :headers="headersDevicesEdit"
              :items="getItemsDevices"
              item-key="id"
              show-select
              :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100],
                }"
              :single-select="true"
              :disable-sort="true"
            >
            </v-data-table>
          </v-card>
          <v-card-actions class="pl-0">
            <div class="edit-buttons">
              <v-btn
                large
                disabled
                color="success"
                class="text-none ma-1"
              >
                Сменить устройство
              </v-btn>
            </div>
          </v-card-actions>
          <v-card-title>Изображение</v-card-title>
          <v-row>
            <v-img
              :src="require('../../../../../public/controller.jpg')"
              max-width="300"
              contain
              class="image-controller mt-2"
            ></v-img>
          </v-row>
        </v-col>
      </v-row>
      <v-card-actions>
        <div class="my-2 mt-4">
          <v-btn
            large
            color="success"
            class="text-none"
            dark
            @click="validate()"
          >
            Сохранить
          </v-btn>
          <v-btn
            large
            class="ma-2 text-none"
            outlined
            dense
            hide-details
            color="error"
            @click.prevent="returnController"
          >
            Отменить
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          @click.stop="dialogWarning = true"
          large
          right
          class="text-none mr-12"
          outlined
          dense
          color="error"
        >
          Удалить контроллера
        </v-btn>
        <v-dialog v-model="dialogWarning" width="500">
          <BaseDeleteModal
            :active.sync="dialogWarning"
            @close="dialogWarning = false"
            @submit="remove()"
            messageTitle="Удалить контроллера"
            messageText="Подтверждая, вы соглашаетесь с выше написанным."/>
        </v-dialog>
      </v-card-actions>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { headersDevicesEdit, physicalStatus } from '../../consts';
import watchTableOptions from '../../../../mixins/watchTableOptions';
import BaseDeleteModal from '../../../BaseDeleteModal';
import BindingDoorphone from './BindingDoorphone';

export default {
  name: 'GeneralInfo',
  components: { BaseDeleteModal, BindingDoorphone },
  mixins: [watchTableOptions],
  props: ['returnController'],
  data: () => {
    return {
      isFirstLoading: true,
      dialog: false,
      physicalStatus,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      universalTotalDevices: 0,
      selectedDevices: [],
      dialogWarning: false,
      headersDevicesEdit,
      dialogImage: false,
      isDistrict: false,
      valid: true,
      searchDevice: '',
      currentDevice: '',
      searchAddress: '',
      typingTimer: null,
      formController: {
        address: {
          addresses: '',
        },
        physicalStatus: '',
        region: null,
        model: '',
        deviceId: null,
      },
      isMobile: false,
    };
  },
  computed: {
    ...mapGetters({
      district: 'Doorphone/districts',
      controllerEdit: 'Controllers/controllerEdit',
      addresses: 'Doorphone/addresses',
      devices: 'Device/devices',
      roleName: 'roleName',
    }),
    getItemsDevices () {
      return this.devices.filter(device => device.id !== this.formController.deviceId);
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  created () {
    this.currentDevice = 'Текущее устройство: ' + this.controllerEdit.controller.ip_address;
    this.addresses[0] = this.controllerEdit.controller.address;
    this.formController.address.addresses = this.controllerEdit.controller.address;
    this.formController.model = this.controllerEdit.controller.model;
    this.formController.agent_id = this.controllerEdit.controller.agent_id;
    this.formController.deviceId = this.controllerEdit.controller.device_id;
    this.formController.physicalStatus = this.controllerEdit.controller.physical_status;
    if (this.controllerEdit.controller.name) {
      this.formController.name = this.controllerEdit.controller.name;
    }

    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
    const filters = ({
      free: 1,
      agent_id: this.formController.agent_id,
      'model.name': this.formController.model,
    });
    this.loadDevices({
      filters,
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      })
      .catch((e) => {
        console.error(e);
        this.$flash_warning('Ошибка при загрзуке устройсв');
      });
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      getAddressSearch: 'Doorphone/getAddressSearch',
      removeController: 'Controllers/removeController',
      updateController: 'Controllers/updateController',
    }),
    updateAddressSearch () {
      const val = this.formController.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formController.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.formController.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = ({
        free: 1,
        agent_id: this.formController.agent_id,
        'model.name': this.formController.model,
      });

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    remove () {
      this.removeController({ id: this.$route.params.id })
        .then(() => {
          this.$router.push({ name: 'Controllers' });
          this.$flash_success('Изменения сохранены!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении');
        });
    },
    async validate () {
      await this.$refs.addressInput.blur();
      let tempDevice;
      if (!this.selectedDevices.length) {
        tempDevice = this.formController.deviceId;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }

      if (this.$refs.formEditController.validate()) {
        const tempController = {
          device_id: tempDevice,
          physical_status: this.formController.physicalStatus,
          name: this.formController.name,
        };
        if (this.formController.region && this.isDistrict) {
          tempController.region_id = this.formController.region;
        }
        if (this.controllerEdit.doorphones[0]) {
          tempController.doorphones = this.controllerEdit.doorphones.map(item => item.id);
        }
        if (typeof this.formController.address === 'object') {
          tempController.address = this.formController.address.addresses;
        } else {
          tempController.address = this.formController.address;
        }
        if (this.formController.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          this.updateController({
            id: this.$route.params.id,
            params: tempController,
          })
            .then(() => {
              this.$router.push({ name: 'DetailController', params: { id: this.$route.params.id } });
              this.$flash_success('Изменения успешно сохранены');
            })
            .catch((message) => {
              if (message.length > 0) {
                for (let i = 0; i < message.length; i++) {
                  this.$flash_warning(message[i]);
                  console.error(message);
                  this.$sentry_exception(message);
                }
              } else {
                this.$flash_warning('Ошибка при изменении информации');
              }
            });
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
  },
};

</script>

<style scoped>
.edit-buttons button.v-btn {
  min-width: 270px;
}
</style>
